module.exports = __webpack_public_path__ + "img/huatai.376d4dca.png";